import { render } from "./SectionHeader.vue?vue&type=template&id=6e96dc1b&scoped=true&ts=true"
import script from "./SectionHeader.vue?vue&type=script&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&lang=ts"

import "./SectionHeader.vue?vue&type=style&index=0&id=6e96dc1b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e96dc1b"]])

export default __exports__